import { render, staticRenderFns } from "./ResponsiveImg.vue?vue&type=template&id=598f6986&"
import script from "./ResponsiveImg.vue?vue&type=script&lang=js&"
export * from "./ResponsiveImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports